const FooterV5 = () => {
  return <footer className="bg-gradient-to-r from-purple-900 via-purple-800 to-indigo-900 py-12">
      <div className="container max-w-6xl mx-auto px-4">
        <div className="text-center space-y-6">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-lg">
              <img alt="Show Up! Mascot" className="w-12 h-12 object-contain" src="/lovable-uploads/34964db8-f0a4-44a4-9ecc-c7bbf0b0dc52.png" />
            </div>
          </div>

          {/* Contact Section */}
          <div className="mb-8">
            <p className="text-white/90 text-lg mb-2">Questions?</p>
            <p className="text-white/80">
              Contact us at{' '}
              <a href="mailto:contact@showupagain.com" className="text-yellow-400 hover:text-yellow-300 font-medium underline transition-colors duration-200">
                contact@showupagain.com
              </a>
            </p>
          </div>

          {/* Social Media */}
          <div className="mb-6">
            <a 
              href="https://x.com/showupagain" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white/90 hover:text-yellow-400 transition-colors duration-200 text-lg font-medium"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              Follow Us on X @showupagain
            </a>
          </div>

          {/* Divider */}
          <div className="border-t border-white/20 pt-6">
            {/* Copyright */}
            <p className="text-white/70 text-sm">
              All rights reserved. © 2024 Show Up Inc.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default FooterV5;